module.exports = __webpack_public_path__ + "img/Money-track.8d457b6f.svg";